import { Mail, Phone, MapPin } from "lucide-react";
import { SiGithub, SiX } from "react-icons/si";
import { FaLinkedin } from "react-icons/fa6";

export const EMAIL = "qhuy14775@gmail.com";

export const SOCIAL_LINKS = [
    { name: "GitHub", url: "https://github.com/quochuy14775", Icon: SiGithub },
    { name: "LinkedIn", url: "https://linkedin.com/in/quochuy14775", Icon: FaLinkedin },
    { name: "Twitter", url: "https://twitter.com/quochuy14775", Icon: SiX },
    { name: "Email", url: `mailto:${EMAIL}`, Icon: Mail },
];

export const INFO_ITEMS = [
    { label: "Email", value: EMAIL, Icon: Mail },
    { label: "Phone", value: "+84 768 464 821", Icon: Phone },
    { label: "Location", value: "Quy Nhơn, Gia Lai · Vietnam", Icon: MapPin },
];
